import React from "react";
import { Badge } from "@/components/ui/badge";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { shouldShowOrganizationColumn } from "@/utils/activeOrganization";
import { cn } from "@/lib/utils";

interface FunderChipProps {
  organizationName?: string | null;
  className?: string;
}

/**
 * Grey chip showing which funder organization an application belongs to.
 * Only shown for multi-org brokers/underwriters — redundant for admins and
 * single-org users.
 */
const FunderChip: React.FC<FunderChipProps> = ({ organizationName, className }) => {
  const { user } = useCurrentUser();
  const name = (organizationName || "").trim();
  if (!name || !shouldShowOrganizationColumn(user)) return null;

  return (
    <Badge
      variant="secondary"
      className={cn("max-w-full truncate font-normal text-muted-foreground", className)}
      title={`Funder: ${name}`}
    >
      Funder: {name}
    </Badge>
  );
};

export default FunderChip;
